import "./style/index.scss";
import App from "./app";
import errorTracking from "./utils/ErrorTracking";

errorTracking.init();
export default App;



// WEBPACK FOOTER //
// ./index.js